import i18n from "../../../../../i18n";
import { createLoading } from "../../../../../utils/loading";
import { createPage, createManageDelete, createManageExportCsv } from "../../../../../utils/page";
import { onClickDeleteAllClient } from "../../../../../utils/form";
import { createColumnInput, createColumnTextTruncate } from "../../../../../components/table/c-table.logic";
import { has } from "../../../../../utils/menu-context";
import { openModalList as openModalListRole } from "../role/role.logic";
import { openModalList as openModalListMenu } from "../menu/menu.logic";
import { onIFrameClickSelectAll } from "../../../../../utils/iframe";
import { createButtonCreate } from "../../../../../utils/button";
import store from "../../../../../store";
import { defineAsyncComponent } from "vue";
import lodash from "lodash";

const AttributeSelect = defineAsyncComponent(() => import("../role/AttributeSelect"));

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/security/roleMenu";
export const routerPrefix = "role-menus";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const createColumns = ({ props, data }) => {
    const { viewOnly, visibleRole, visibleMenu } = props;
    const { useForm } = data;
    const columns = [];
    if (visibleRole) {
        columns.push(createColumnInput({ title: () => i18n.global.t("model.role.name"), dataIndex: "refRole.name", align: "center" }));
        columns.push(createColumnInput({ title: () => i18n.global.t("model.role.desc"), dataIndex: "refRole.desc" }));
    }
    if (visibleMenu) {
        columns.push(createColumnInput({ title: () => i18n.global.t("model.menu.name"), dataIndex: "refMenu.name" }));
        columns.push(createColumnInput({ title: () => i18n.global.t("model.menu.desc"), dataIndex: "refMenu.desc" }));
        columns.push(createColumnInput({ title: () => i18n.global.t("model.menu.url"), dataIndex: "refMenu.url" }));
        columns.push(
            createColumnTextTruncate({
                title: () => i18n.global.t("model.menu.attribute"),
                dataIndex: "refMenu.attribute",
                search: {
                    visible: () => false
                }
            })
        );
    }
    columns.push({
        title: () => i18n.global.t("model.roleMenu.attribute"),
        dataIndex: "attribute",
        sorter: false,
        width: 150,
        align: "left",
        visible: () => true,
        search: {
            visible: () => false
        },
        customRender: ({ record }) => (
            <AttributeSelect
                viewOnly={viewOnly}
                validateInfo={useForm.validateInfos.attributeStr}
                masterAttribute={props.masterAttribute || record.refMenu.attribute}
                record={record}
            ></AttributeSelect>
        )
    });
    return columns;
};

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey, visibleRole, visibleMenu } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: items });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => (viewOnly ? false : has({ menuContext, key: "canDelete" })),
            onClick: ({ rowSelection }) => {
                onClickDeleteAllClient({ rowSelection, useForm, items, key: itemsKey });
                data.page.page = 0;
            }
        }),
        createManageExportCsv({ menuContext })
    ];
    data.manageExtras = [];
    data.rowActions = [];

    if (!viewOnly) {
        if (visibleRole) {
            data.manageExtras.push({
                render: () => ({
                    ...createButtonCreate({
                        onClick: () =>
                            openModalListRole({
                                onIframeMounted: ({ refs, options }) =>
                                    onIFrameClickSelectAll({
                                        refs,
                                        options,
                                        items,
                                        itemKey: "refRole.id",
                                        rowKey: "id",
                                        setKey: "refRole"
                                    })
                            }),
                        options: { text: i18n.global.t("model.role.modelName") }
                    })
                }),
                visible: () => has({ menuContext, key: "canCreate" })
            });
        }
        if (visibleMenu) {
            data.manageExtras.push({
                render: () => ({
                    ...createButtonCreate({
                        onClick: () =>
                            openModalListMenu({
                                onIframeMounted: ({ refs, options }) =>
                                    onIFrameClickSelectAll({
                                        refs,
                                        options,
                                        items,
                                        itemKey: "refMenu.id",
                                        rowKey: "id",
                                        setKey: "refMenu"
                                    })
                            }),
                        options: { text: i18n.global.t("model.menu.modelName") }
                    })
                }),
                visible: () => has({ menuContext, key: "canCreate" })
            });
        }
    }

    fetchData({ props, data }).then(page => items.push(...page.data));
};

export const fetchData = ({ props }) => {
    const { fetchCriteria } = props;
    if (!fetchCriteria || fetchCriteria.fetched) {
        return Promise.resolve({ data: [] });
    }
    fetchCriteria.fetched = true;
    setIsLoading(true);
    return callSearch({ criteria: fetchCriteria }).finally(() => setIsLoading(false));
};
